import React from 'react';

import { connect } from 'react-redux';

class SearchSmallIcon extends React.Component {
  render() {
    const fill = this.props.overrideColor || this.props.color || '#DE171F';
    return (
      <svg {...this.props}>
        <g transform="matrix(0.82678783,0,0,0.82673313,-8.2678276e-4,-2.0641572e-4)"><path
       d="m 20.194,3.46 c -4.613,-4.613 -12.121,-4.613 -16.734,0 -4.612,4.614 -4.612,12.121 0,16.735 4.108,4.107 10.506,4.547 15.116,1.34 0.097,0.459 0.319,0.897 0.676,1.254 l 6.718,6.718 c 0.979,0.977 2.561,0.977 3.535,0 0.978,-0.978 0.978,-2.56 0,-3.535 l -6.718,-6.72 C 22.432,18.898 21.993,18.675 21.534,18.578 24.743,13.967 24.303,7.57 20.194,3.46 Z m -2.121,14.614 c -3.444,3.444 -9.049,3.444 -12.492,0 -3.442,-3.444 -3.442,-9.048 0,-12.492 3.443,-3.443 9.048,-3.443 12.492,0 3.444,3.444 3.444,9.048 0,12.492 z"
       fill={fill}
       /></g>
      </svg>
    );
  }
}

function mapStateToProps(state) {
  return {
    color: state.rr360.theme.primaryColor
  };
}


export default connect(mapStateToProps, undefined)(SearchSmallIcon);



// WEBPACK FOOTER //
// ./src/icons/search-small.js